// Wrap the getAccountInfoAction to get the account info
// because this action only used to login and update the connecting status
import { createAsyncThunk, isFulfilled, isRejected } from '@reduxjs/toolkit'
import { AccountInfo } from '../../../api/v1/account'
import { Web3Provider } from '@ethersproject/providers'
import { AccountInterface } from 'starknet'
import { sdk } from '../../../utils/signer/utils'
import { RootState } from '../../index'
import { isStarknetProvider } from '../../link/actions/connectLinkWalletActions'
import { getAccountInfoAction } from './getAccountInfoActions'
import authorization from '../../../utils/authorization'

import { AUTHORIZATION_MESSAGE } from '../../../constants/authorization'
import { updateModal } from 'store/app/actions/modalActions'
import toastify from 'components/Toastify'
import { disconnectLink } from 'store/link/actions'

export async function buildLoginData(
  provider: Web3Provider,
  signer: sdk.JsonRpcSigner,
) {
  const web3Signer = provider.getSigner()
  const address = await web3Signer.getAddress()
  const pubKey = signer.getPubkey()

  let web3Signature = ''
  // check if the user has authorized the current address
  if (!authorization.has(address)) {
    web3Signature = await web3Signer.signMessage(AUTHORIZATION_MESSAGE)
  }

  return {
    address,
    signature: web3Signature,
    pubKey,
  }
}

export async function buildStarknetLoginData(
  account: AccountInterface,
  signer: sdk.JsonRpcSigner,
) {
  const address = account.address
  const pubKey = await account.signer.getPubKey()

  let web3Signature = ''
  // check if the user has authorized the current address
  // if (!authorization.has(address)) {
  //   web3Signature = await account.signMessage(AUTHORIZATION_MESSAGE)
  // }

  return {
    address,
    signature: web3Signature,
    pubKey,
  }
}

export const connectZkexAction = createAsyncThunk<
  AccountInfo | null,
  {
    provider: Web3Provider | AccountInterface
    signer: sdk.JsonRpcSigner
  },
  { state: RootState }
>('account/connectZkexAction', async ({ provider, signer }, { dispatch }) => {
  if (!provider) {
    throw new Error('Provider is not ready')
  }
  if (!signer) {
    throw new Error('Signer is not ready')
  }
  const { address, signature, pubKey } = isStarknetProvider(provider)
    ? await buildStarknetLoginData(provider as AccountInterface, signer)
    : await buildLoginData(provider as Web3Provider, signer)

  const actionResult = await dispatch(
    getAccountInfoAction({
      address,
      signature,
      pubKey,
    }),
  )

  if (isRejected(actionResult)) {
    dispatch(updateModal({ modal: 'verify', open: false }))
    if (actionResult.error.message) {
      toastify.error(actionResult.error.message)
    }
  }

  return isFulfilled(actionResult) ? actionResult.payload : null
})
